import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAQWI-k0vcW-ZYtpYe5snt6d-EJVnJQcgo",
  authDomain: "formulaquim-3e6cd.firebaseapp.com",
  databaseURL: "https://formulaquim-3e6cd.firebaseio.com",
  projectId: "formulaquim-3e6cd",
  storageBucket: "formulaquim-3e6cd.appspot.com",
  messagingSenderId: "392201154353",
  appId: "1:392201154353:web:ff49bfcbbdadb3d5d0ca10",
  measurementId: "G-ESEDQ5FHC3"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseFS = firebaseApp.firestore();
export const firebaseAuth = firebaseApp.auth();
export const firebaseValue = firebase.firestore.FieldValue;
export const firebaseTimeStamp = firebase.firestore.Timestamp;